<template>
  <el-aside class="right" :class="{ 'open': showContent, 'disabled': isPreview }" :width="sidebarWidth">
    
    <div class="wrapper">
      <div class="top">
      </div>
      <div class="content">
        <div v-for="tab in availableTabs" :is="tab.key" :key="tab.key" />
      </div>
    </div>
    
    <el-menu class="menubar" @select="selectMemuItem" :collapse="true">
      <el-menu-item v-for="tab in showAvailableTabs" :index="tab.key" :key="tab.key">
        <i :class="tab.icon"></i>
        <span slot="title">
          {{ tab.name }}
        </span>
      </el-menu-item>
    </el-menu>
    
  </el-aside>
</template>

<script>
  import Texts from './RightSidebar/Texts.vue';
  import Quotes from './RightSidebar/Quotes.vue';
  import Rhyme from './RightSidebar/Rhyme.vue';
  import Format from './RightSidebar/Editor.vue';
  import Images from './RightSidebar/Images.vue';
  import Layers from './RightSidebar/Layers.vue';
  import Qrcode from './RightSidebar/Qrcode.vue';
  import Vector from './RightSidebar/Vector.vue';
  import Backgrounds from './RightSidebar/Backgrounds.vue';
  import { mapGetters } from 'vuex';
  import Editor from '../classes/Editor'

  export default {
    data() {
      return {
        showContent: false,
        activeItem: 'format',
        tabs: [
          { name: 'Formatowanie', key: 'format', icon: 'el-icon-s-operation', forceShow: true },
          { name: 'Tła', key: 'backgrounds', icon: 'el-icon-picture-outline' },
          { name: 'Obrazki', key: 'images', icon: 'el-icon-picture-outline' },
          { name: 'Teksty', key: 'texts', icon: 'el-icon-edit' },
          { name: 'Cytaty', key: 'quotes', icon: 'el-icon-chat-line-round' },
          { name: 'Rymy', key: 'rhyme', icon: 'el-icon-chat-line-square' },
          { name: 'Qrcode', key: 'qrcode', icon: 'el-icon-full-screen' },
          { name: 'Vector', key: 'vector', icon: 'el-icon-news' },
        ]
      }
    },
    computed: {
      ...mapGetters('user', [
        'loggedIn',
      ]),
      ...mapGetters('creator', [
        'scene',
        'version',
        'isPreview'
      ]),
      isMobile() {
        return window.innerWidth < 1024
      },
      sidebarWidth() {
        return this.isMobile ? '100%' : '400px'
      },
      showAvailableTabs() {
        return this.tabs.filter((tab) => this.showTab(tab))
      },
      availableTabs() {
        return this.tabs.filter((tab) => this.showTab(tab) && this.activeItem === tab.key)
      }
    },
    mounted() {
      Editor.addCallback(['selection:created', 'selection:updated'], () => {
        this.selectMemuItem(this.getTabByType(Editor.canvas.getActiveObject().type))
      })
      // Editor.addCallback(['selection:cleared'], () => this.selectMemuItem(null))
    },
    methods: {
      getTabByType(type) {
        switch (type) {
          case 'rect':
          case 'line':
          case 'circle':
          case 'group':
          case 'path':
            return 'vector'
          default:
            return 'format'
        }
      },
      showTab(tab) {

        if (this.loggedIn || tab.forceShow) {
          return true;
        }

        if (!this.scene) {
          return false
        }

        const tabs = this.scene.attributes.tabs || ''

        return tabs.split(',').includes(tab.key);
      },
      selectMemuItem(menuItem) {
        this.activeItem = menuItem
      }
    },
    components: {
      Qrcode,
      Rhyme,
      Texts,
      Format,
      Images,
      Quotes,
      Layers,
      Vector,
      Backgrounds
    }
  }
</script>

<style lang="less" scoped>
  .rightToggle {
    background: #fff;
    color: #222;
    text-align: center;
    padding: 5px;
    @media (min-width: 1024px) {
      display: none;
    }
  }
  .right {
    @media (max-width: 1023px) {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #fff;
      width: 100%;
      padding: 0;
      box-sizing: border-box;
      box-shadow: 0 0 10px rgba(0, 0, 0, .3);
    }

    @media (min-width: 1024px) {
      width: 400px;
      background: #fff;
      max-height: 100vh;
      display: flex;
      flex-direction: row;
      padding: 0;
      border-left: 2px solid #f1f4fa;
    }

    &.mobile {
      position: fixed;
      bottom: 0;
      width: 100vw;
      left: 0;
      transform: translateY(calc(100% - 80px));
      transition: transform .4s;
      &.open {
        transform: translateY(0);
      }
    }
    &.disabled {
      opacity: .3;
      pointer-events: none;
    }
  }
  .content {
    @media (max-width: 1023px) {
      max-height: 150px;
      overflow: auto;
      padding: 0 20px;
    }

    overflow: auto;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
  .el-collapse-item__content {
    .el-row + .el-row {
      margin-top: 10px;
    }
  }
  .menubar {
    display: flex;
    background: #f7f7f7;
    border-left: 1px solid #ebeaea;
    padding: 0;
    margin: 0;

    @media (max-width: 1023px) {
      box-shadow: 0 0 10px rgba(0, 0, 0, .3);
      width: 100%;
      border: 0;
    }

    @media (min-width: 1024px) {
      flex-direction: column;
      justify-content: center;
    }
  }
  .el-menu-item {
    padding: 0 30px !important;
  }
  .wrapper {
    width: 100%;
  }

  .top {
    height: 62px;
    border-bottom: 2px solid #f1f4fa;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .bar {
    padding: 8px 0;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;

    span {
      color: #707174;
      font-size: 22px;
      padding: 5px;
      background: transparent;
      transition: .3s color, background;

      &.disabled {
        color: #bbbfcf;
        pointer-events: none;
      }

      &:hover,
      &.active {
        cursor: pointer;
        background: #fff;
        color: #000;
        border-radius: 5px;
        transition: .3s color, background;
        box-shadow: 0 0 10px 2px rgba(0, 0, 0, .05);
      }

      + span {
        margin-left: 25px;
      }
    }
    + .bar {
      margin-top: 16px;
    }
  }
</style>